module.exports = __webpack_public_path__ + "img/logo.47d53985.svg";